//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

/**
 * Is the current user agent Safari?
 *
 * @deprecated Please never use browser sniffing if at all avoidable. Prefer feature detection.
 */
export function isSafari() {
    // Primitive check for safari.
    // Will probably err on the side of false-positive.
  const ua = navigator.userAgent.toLowerCase();
    // This should be compatible with Chromium Edge as well, but we should re-check when it ships.
    // (it has "Safari" in its UA, like many webkit-forked browsers do)
  return ua.includes('safari') && !ua.includes('chrome');
}
